module.exports = __webpack_public_path__ + "static/selfie-eb5175950e7aec63400e52bd570c46fc.png";